<template>
    <v-container>
        <!-- title / add  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <v-toolbar flat>
            <v-toolbar-title class="text-uppercase body-1 font-weight-medium">Storage Costs</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>

            <div class="flex-grow-1"></div>

            <!-- add ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                <v-btn v-on="on" fab small text>
                    <v-icon large color="orange darken-2">mdi-plus-circle-outline</v-icon>
                </v-btn>
                </template>
                <!-- add dialog ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm12>
                          <v-text-field
                            v-model="editedItem.currentState"
                            label="Current State"
                            suffix="kWh"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="editedItem.limitHi"
                            label="High Limit"
                            suffix="kWh"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="editedItem.limitLo"
                            label="Low Limit"
                            suffix="kWh"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="editedItem.chargeRate"
                            label="Charge Rate"
                            suffix="kW"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="editedItem.dischargeRate"
                            label="Discharge Rate"
                            suffix="kW"
                            required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="close" small color="primary" text>Cancel</v-btn>
                    <v-btn @click.native="save" small color="primary" >Save</v-btn>
                  </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>

    <!-- table ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <v-data-table
            :headers="headers"
            :items="components"
            :search="search"
            :sort-by="['limitHi']"
            :sort-desc="[false]"
            hide-default-footer
            multi-sort
            class="mb-5">

            <!-- no-data ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template slot="no-data" class="text-left">
                <v-alert :value="true" color="info" dark>
                    <span class="title text-left">
                        <v-icon color="orange">warning</v-icon>
                        No components found.
                    </span>
                </v-alert>
            </template>

            <!-- content ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template v-slot:item.currentState="{ item }">
                {{ item.currentState }} <small>kW</small>
            </template>
            <template v-slot:item.limitHi="{ item }">
                {{ item.limitHi }} <small>kWh</small>
            </template>
            <template v-slot:item.limitLo="{ item }">
                {{ item.limitLo }} <small>kWh</small>
            </template>
            <template v-slot:item.chargeRate="{ item }">
                {{ item.chargeRate }} <small>kW</small>
            </template>
            <template v-slot:item.dischargeRate="{ item }">
                {{ item.dischargeRate }} <small>kW</small>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon @click="editItem(item)" class="mr-2" color="primary">
                    edit
                </v-icon>
                <v-icon @click="deleteItem(item)" color="red darken-2">
                  delete_forever
                </v-icon>
            </template>
        </v-data-table>

    </v-container>
</template>

<script>
export default {
  data: () => ({
    pagination: {
      sortBy: 'currentState'
    },
    search: '',
    dialog: false,
    headers: [
      { text: 'Current State', sortable: true, value: 'currentState' },
      { text: 'High Limit', sortable: true, value: 'limitHi' },
      { text: 'Low Limit', sortable: true, value: 'limitLo' },
      { text: 'Charge Rate', sortable: true, value: 'chargeRate' },
      { text: 'Discharge Rate', sortable: true, value: 'dischargeRate' },
      { text: 'Actions', sortable: false, value: 'actions' }
    ],
    components: [],
    editedItem: {
      currentState: '',
      limitHi: '',
      limitLo: '',
      chargeRate: '',
      dischargeRate: ''
    },
    defaultItem: {
      currentState: '',
      limitHi: '',
      limitLo: '',
      chargeRate: '',
      dischargeRate: ''
    }
  }),
  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      this.components = [
        {
          currentState: 857.8,
          limitHi: 1048.0,
          limitLo: 38.2,
          chargeRate: 2487.6,
          dischargeRate: 2140.2
        }
      ]
    },

    editItem(item) {
      this.editedIndex = this.components.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.components.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.components.splice(index, 1)
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      this.$toast.success("Component saved successfully")
      if (this.editedIndex > -1) {
        Object.assign(this.components[this.editedIndex], this.editedItem)
      } else {
        this.components.push(this.editedItem)
      }
      this.close()
    }
  }
}
</script>
